<template>
    <div>
        <!-- {{$route.name}} -->
        <!-- {{$router.currentRoute}} -->
        <v-tabs
            centered
            dark
            color="teal"
            show-arrows
            v-model="activeTab"
            grow
        >
            <v-tab
                v-for="item in items"
                :key="item.title"
                @click="navTo(item)"
                class="headline"
            >
            {{ item.title }}
            </v-tab>
        </v-tabs>
        <!-- {{userData}} -->
    </div>
    <!-- <v-tabs-slider color="yellow"></v-tabs-slider> -->


    <!-- <v-tabs-items>
      <v-tab-item
        v-for="i in 30"
        :key="i"
        :value="'tab-' + i"
      >
        <v-card flat>
          <v-card-text>{{ text }}</v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items> -->
  <!-- <v-card
    class="hide-overflow"
    height="60px"
  >


    <v-bottom-nav
      
      :value="showNav"
      absolute
      color="transparent"
      dark
    >
      <v-btn flat color="teal" 
        @click="navTo(item)"
        v-for="item in items"
        :key="item.title">
        <span>{{ item.title }}</span>
        <v-icon>{{ item.icon }}</v-icon>
      </v-btn>

    </v-bottom-nav>
  </v-card> -->
    <!-- <v-layout wrap>
        <v-flex 
            xs12 sm4
            px-3 py-2
            v-for="item in items"
            :key="item.title"
        >
            <v-list two-line subheader class="grey lighten-3" >
                <v-list-tile theme--light
                    avatar
                    @click="navTo(item)"
                >
                    <v-list-tile-avatar>
                    <v-icon :class="[item.iconClass]">{{ item.icon }}</v-icon>
                    </v-list-tile-avatar>

                    <v-list-tile-content>
                    <v-list-tile-sub-title>{{ item.subtitle }}</v-list-tile-sub-title>
                    <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                    </v-list-tile-content>

                    <v-list-tile-action>
                    <v-btn icon ripple>
                        <v-icon color="grey lighten-1">arrow_forward</v-icon>
                    </v-btn>
                    </v-list-tile-action>
                </v-list-tile>

            </v-list>

        </v-flex>
    </v-layout> -->
</template>
<script>
import {mapGetters} from 'vuex'
import { PULSE_ROUTES, pulseLandingRoute, pulseMenuTitle } from '@/services/pulseAccess'
export default {
    // props: ['activeTab'],
    data() {
        return {
            // activeBtn: null,
            showNav: true,
            activeTab: 0,
            items: [
                { icon: 'build', iconClass: 'blue lighten-1 white--text', title: 'Home', subtitle: 'Home', route: 'home' },
                { icon: 'add_circle', iconClass: 'blue lighten-1 white--text', title: 'New Quote', subtitle: 'Start a new quote', route: 'pub-quote-new' },
                { icon: 'search', iconClass: 'blue lighten-1 white--text', title: 'Find Quote', subtitle: 'Advanced search', route: 'pub-quotes'  },
                // title and route are set per user in created(); 'key' is how created() finds this entry.
                { key: 'pulse', icon: 'search', iconClass: 'blue lighten-1 white--text', title: 'PULSE', subtitle: 'Chat, wiki and item search', route: 'item-search'  },
                
            ],
        }
    },
    computed: {
        ...mapGetters("auth", [
        "authenticating",
        "authenticationError",
        "authenticationErrorCode",
        'userHasPublicRole',
        'userHasInternalRole',
        'userHasSalesSupportRole',
        'userHasSalesRepRole',
        'userHasSysAdminRole',
        'userData',
        'isHMInternalSite',
        'userHasContractdeptRole',
        ]),
        // isHMInternalSite() {
        //     return process.env.VUE_APP_ROOT_API == '/'
        // },
        // activeTab() {
        //     return this.items.findIndex(item => item.route == this.$route.name) 
        // }
    },
    methods: {
        navTo(item){
            this.$router.push({ name: item.route})
        }
    },
    created() {
        // The PULSE entry leads wherever this user is actually allowed to go (Chat, else Wiki,
        // else the plain item search page), and a search-only user sees it under its old
        // Item / Product Search name.
        const pulseItem = this.items.find(item => item.key == 'pulse')
        if (pulseItem) {
          pulseItem.route = pulseLandingRoute(this.userData)
          pulseItem.title = pulseMenuTitle(this.userData)
        }

        // All three Pulse routes highlight the one PULSE menu entry, whichever of them the
        // user landed on.
        const pulseRouteNames = [PULSE_ROUTES.chat, PULSE_ROUTES.wiki, PULSE_ROUTES.search]
        this.activeTab = pulseRouteNames.indexOf(this.$route.name) !== -1
          ? this.items.findIndex(item => item.key == 'pulse')
          : this.items.findIndex(item => item.route == this.$route.name)

        if(this.userHasInternalRole) {
          this.items.push({ icon: 'search', iconClass: 'blue lighten-1 white--text', title: 'Find My Rep', subtitle: 'Find Sales Rep by ZIP Code', route: 'sales-rep-search'  })
        }

        // if(this.userHasSalesRepRole || this.userHasContractdeptRole) {
          //20210204, hard code following users
          if(!this.userData || this.userData.userName != 'hassan@famos-medical.com') {
            this.items.push({ icon: 'search', iconClass: 'blue lighten-1 white--text', title: 'GPO Contracts', subtitle: '', route: 'gpo-contracts'  })

          }
        // }
        // 20201123, Steve want only user inside HM network can open this Map. So added this logic here
        if(this.isHMInternalSite) {
          if(this.userHasSysAdminRole || this.userHasSalesSupportRole) {
            this.items.push({ icon: 'build', iconClass: 'blue lighten-1 white--text', title: 'Map Tool', subtitle: 'Distribute ZIPs', route: 'zips-assign-map-saved-list'  })
          }

        }
    },
}
</script>
